var render, staticRenderFns
import script from "./ChartVerticalBarPlugin.vue?vue&type=script&lang=js"
export * from "./ChartVerticalBarPlugin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f9777e",
  null
  
)

export default component.exports